import React, { Component } from 'react'
import { BsLightbulb } from 'react-icons/bs'
import { ActiveSign, AgentName, Avatar, BadgeBlue, ContactNumber, NotificationBar, NotificationName, ProfileBar, Sign, Time, UserList } from '../styles/dialpadstyle'

export class NotificationTheme extends Component {

    renderList(icon, name, desc, time) {
        return (
            <NotificationBar style={{ marginBottom: '10px' }}>

                <NotificationName style={{ color: '#303030' }}><span style={{fontSize: '10px', marginRight: '5px'}}>{icon}</span>{name}<shape style={{ background: '#bbb', width: '4px', height: '4px', display: 'inline-block', borderRadius: '50px', marginLeft: '5px', marginRight: '3px' }}></shape><span style={{ color: '#bbb', fontSize: '12px' }}>{time}</span></NotificationName>
                <div style={{color: '#A6A6A6'}}>{desc}</div>

            </NotificationBar>
        )
    }


    render() {
        return (
            <span style={{ display: 'block', width: '100%' }}>
                <UserList>
                    {this.renderList(
                        <BsLightbulb />,
                        'Enjoy using the app?',
                        `Description about the notification`,
                        'Now',
                    )}
                    {this.renderList(
                        <BsLightbulb />,
                        'Olivia Williams',
                        `How are you?`,
                        'Now',
                    )}
                    {this.renderList(
                        <BsLightbulb />,
                        'Olivia Williams',
                        `How are you?`,
                        'Now',
                    )}
                    {this.renderList(
                        <BsLightbulb />,
                        'Olivia Williams',
                        `How are you?`,
                        'Now',
                    )}
                    {this.renderList(
                        <BsLightbulb />,
                        'Olivia Williams',
                        `How are you?`,
                        'Now',
                    )}
                </UserList>
            </span>
        )
    }
}

export default NotificationTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/NotificationTheme.js